/** @type {import('../help-index.js').HelpSidebarItem} */
export const MET_ART_SALES_ITEM = {
  id: 'products_sales',
  screenId: 'met-art-sales',
  label: 'Ventas por producto',
  description: 'Compará hasta 6 productos y su evolución diaria de ventas.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Elegís productos concretos y ves cuánto facturaron en el período y cómo variaron día a día. Sirve para comparar artículos entre sí.',
      },
      {
        title: 'Paso 1 — Elegir período',
        bullets: [
          'Atajos: Hoy, Semana, Mes, Mes anterior o Personalizado (desde / hasta + Aplicar).',
          'Los importes están en pesos al tipo de cambio de cada factura.',
        ],
      },
      {
        title: 'Paso 2 — Agregar productos',
        bullets: [
          'En «Agregar producto al comparativo» escribí al menos 3 letras y elegí un artículo de la lista.',
          'Podés sumar hasta 6 productos. Cada uno aparece como una etiqueta con color.',
          'Tocá la × en la etiqueta para quitar un producto del gráfico.',
          'Si el producto ya está agregado, el sistema te avisa.',
        ],
      },
      {
        title: 'Paso 3 — Leer el comparativo',
        bullets: [
          'Tarjetas con total facturado y cantidad vendida por producto.',
          'Gráfico «Evolución diaria de ventas» — una línea por producto a lo largo del período.',
          'Si no elegiste productos, la pantalla te indica que busques y selecciones al menos uno.',
        ],
      },
    ],
  },
}
